<template>
  <div id="app">
    <div v-if="mask" id="mask" @click="closeMask"></div>
    <div v-if="mask" id="top">
      <img src="@/assets/arrow.png" class="arrow" alt="">
      <p class="top-text">请点击右上角按钮，选择「在浏览器中打开」</p>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  computed: {
    mask() {
      return this.$store.state.mask
    }
  },
  methods: {
    closeMask() {
      this.$store.commit('updateMask', false)
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  max-width: 750px;
  min-width: 320px;
  margin: 0 auto;
}

#top {
  width: 100%;
  position: absolute;
  top: 0;
  z-index: 999;
  text-align: right;
}

.top-text {
  font-size: 0.28rem;
  white-space: nowrap;
  text-align: right;
  margin-right: 0.5rem;
  color: #fff;
}

.arrow {
  margin-right: 0.5rem;
  width: 1.08rem;
  height: 1.16rem;
  margin-top: 30px;
  display: inline-block;
}

#mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 998;
  /* pointer-events: none; */
}
</style>
